import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import ThumbsUpSvg from './svg/ThumbsUp'
import ThumbsDownSvg from './svg/ThumbsDown'

import './FaqSuggestion.scss'

function FaqSuggestion(props) {
  const [activeThumbUp, setActiveThumbUp] = useState(0)
  const [activeThumbDown, setActiveThumbDown] = useState(0)

  const { handleScoring, handleFaqDownVoteResponse, faqId } = props

  const SCORE = {
    up: 'up',
    down: 'down',
  }

  const handleThumbs = thumbActionType => {
    if (thumbActionType === SCORE.up) {
      // if thumbs down is already active, do nothing
      if (activeThumbDown) return

      setActiveThumbUp(!activeThumbUp)
      handleScoring({
        faqId,
        score: SCORE.up,
      })
    } else if (thumbActionType === SCORE.down) {
      // if thumbs up is already active, do nothing
      if (activeThumbUp) return

      setActiveThumbDown(!activeThumbDown)
      handleScoring({
        faqId,
        score: SCORE.down,
      })
      handleFaqDownVoteResponse()
    }
  }

  return (
    <div className="FaqSuggestion">
      <div className="FaqSuggestion__thumbs">
        <div className="container">
          <div className="FaqSuggestion__description">
            <FormattedMessage id="global.label.wasThisHelpful" />
          </div>
          <div className="row justify-content-center">
            <div
              className="FaqSuggestion__thumbs__up__container"
              onClick={() => handleThumbs('up')}
              onKeyDown={() => handleThumbs('up')}
            >
              <ThumbsUpSvg
                className={`FaqSuggestion__thumbs__up ${
                  activeThumbUp ? 'FaqSuggestion__thumbs__active' : ''
                }`}
                alt="thumbs_up"
              />
            </div>

            <div
              className="FaqSuggestion__thumbs__down__container"
              onClick={() => handleThumbs('down')}
              onKeyDown={() => handleThumbs('up')}
            >
              <ThumbsDownSvg
                className={`FaqSuggestion__thumbs__down ${
                  activeThumbDown ? 'FaqSuggestion__thumbs__active' : ''
                }`}
                alt="thumbs_up"
              />
            </div>
          </div>
        </div>
        {activeThumbUp || activeThumbDown ? (
          <div className="FaqSuggestion__thumbs__thankyou">
            <FormattedMessage id="global.label.feedbackThankYou" />
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default FaqSuggestion
